export default () => {
  const sliderParents = document.querySelectorAll('.js-product-slider-parent')

  if (sliderParents.length < 1) return
  if (document.body.clientWidth < 1000) return
  ;[...sliderParents].forEach(sliderParent => {
    // Variables
    const slider = sliderParent.querySelector('.js-product-slider')
    // const slides = sliderParent.querySelectorAll('.js-product-slide')
    const firstSlide = sliderParent.querySelector('.js-product-slide')
    const next = sliderParent.querySelector('.js-product-slider-next')
    const prev = sliderParent.querySelector('.js-product-slider-prev')

    const slidesCount = sliderParent.querySelectorAll('.js-product-slide')
      .length
    let slideWidth = firstSlide.offsetWidth
    let sliderWidth = slider.offsetWidth
    let sliderScrollWidth = slider.scrollWidth

    let pos = 0
    let shown = sliderWidth

    // Recalculate on resize
    window.addEventListener('resize', () => {
      slideWidth = firstSlide.offsetWidth
      sliderWidth = slider.offsetWidth
      sliderScrollWidth = slider.scrollWidth
      pos = 0
      shown = sliderWidth
      setTransform()
      navActivity()
    })

    // Events
    prev.addEventListener('click', () => {
      goPrev()
      navActivity()
      // currentSlide()
    })

    next.addEventListener('click', () => {
      goNext()
      navActivity()
      // currentSlide()
    })

    document.addEventListener('keydown', e => {
      if (e.keyCode === 39) {
        goNext()
        navActivity()
      }
      if (e.keyCode === 37) {
        goPrev()
        navActivity()
      }
    })

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + -pos * slideWidth + 'px,0,0)'
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0)
        setTransform()
        shown = shown - slideWidth
      }
    }

    function goNext() {
      if (shown < sliderScrollWidth) {
        pos = Math.min(pos + 1, slidesCount - 1)
        setTransform()
        shown = shown + slideWidth
      }
    }

    function navActivity() {
      if (pos > 0) {
        if (prev.classList.contains('inactive')) {
          prev.classList.remove('inactive')
        }
      } else {
        if (!prev.classList.contains('inactive')) {
          prev.classList.add('inactive')
        }
      }

      if (shown < sliderScrollWidth) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive')
        }
      } else {
        if (!next.classList.contains('inactive')) {
          next.classList.add('inactive')
        }
      }
    }

    /**
     * Add .current to the currently visible slider on the far left
     * NOTE: remember to add .current to the first slide in twig file
     */
    // function currentSlide() {
    //   ;[...slides].forEach( (slide, index) => {
    //     if (index === pos) {
    //       if (! slide.classList.contains('current')) {
    //         slide.classList.add('current')
    //       }
    //     } else {
    //       if (slide.classList.contains('current')) {
    //         slide.classList.remove('current')
    //       }
    //     }
    //   })
    // }
  }) // end foreach
}



// WEBPACK FOOTER //
// ./src/js/modules/ProductSlider.js